import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "required" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "required" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "required" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "required" }
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "required" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "required" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "row mb-6" }
const _hoisted_69 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_70 = { class: "col-lg-8 fv-row" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "row mb-6" }
const _hoisted_79 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_80 = { class: "col-lg-8 fv-row" }
const _hoisted_81 = { class: "fv-plugins-message-container" }
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = { class: "row mb-6" }
const _hoisted_84 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_85 = { class: "col-lg-8 fv-row" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "row mb-6" }
const _hoisted_89 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_90 = { class: "col-lg-8 fv-row" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = { class: "row mb-6" }
const _hoisted_97 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "col-lg-8 fv-row" }
const _hoisted_99 = { class: "row mb-6" }
const _hoisted_100 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_101 = { class: "col-lg-8 fv-row" }
const _hoisted_102 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_103 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_104 = {
  class: "input-group",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "965+", -1)
const _hoisted_106 = { class: "fv-plugins-message-container" }
const _hoisted_107 = { class: "fv-help-block" }
const _hoisted_108 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = {
  key: 0,
  role: "alert"
}
const _hoisted_112 = { class: "col-lg-2" }
const _hoisted_113 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_114 = ["value"]
const _hoisted_115 = ["disabled", "onClick"]
const _hoisted_116 = { class: "row mb-6" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1)
const _hoisted_118 = { class: "col-lg-8 fv-row" }
const _hoisted_119 = { class: "svg-icon svg-icon-1" }
const _hoisted_120 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_121 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_122 = { class: "indicator-label" }
const _hoisted_123 = { class: "indicator-progress" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_125 = { class: "card mb-5 mb-xl-10" }
const _hoisted_126 = { class: "card-header border-0" }
const _hoisted_127 = { class: "card-title m-0" }
const _hoisted_128 = { class: "fw-bolder m-0" }
const _hoisted_129 = { class: "card-body border-top p-9" }
const _hoisted_130 = { class: "table" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Guardian Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_132 = { class: "fv-plugins-message-container" }
const _hoisted_133 = { class: "fv-help-block" }
const _hoisted_134 = { class: "fv-plugins-message-container" }
const _hoisted_135 = { class: "fv-help-block" }
const _hoisted_136 = { class: "col-lg-12 fv-row" }
const _hoisted_137 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_138 = ["value"]
const _hoisted_139 = { class: "fv-plugins-message-container" }
const _hoisted_140 = { class: "fv-help-block" }
const _hoisted_141 = { class: "input-group" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "965+", -1)
const _hoisted_143 = { class: "fv-plugins-message-container" }
const _hoisted_144 = { class: "fv-help-block" }
const _hoisted_145 = ["onClick"]
const _hoisted_146 = {
  key: 0,
  class: "alert alert-info d-flex justify-content-center"
}
const _hoisted_147 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_148 = ["disabled"]
const _hoisted_149 = { class: "indicator-label" }
const _hoisted_150 = { class: "indicator-progress" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Attachment = _resolveComponent("Attachment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'customer'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewCustomer')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('Name')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Name')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "name" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('email')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "email",
                        name: "email",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Email')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "email" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('Residency Number')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "residencyNumber",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Residency Number')
                      }, null, 8, ["placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate('Nationality')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "nationalityId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedNationality,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedNationality) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate('select Nationality')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nationalities, (nationality) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: nationality.id,
                              value: nationality.id
                            }, _toDisplayString(nationality.nameEn), 9, _hoisted_25))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "nationalityId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.translate('Genders')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "genderId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedGender,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedGender) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.translate('select Gender')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (gender) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: gender.id,
                              value: gender.id
                            }, _toDisplayString(gender.nameEn), 9, _hoisted_33))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ErrorMessage, { name: "genderId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.translate('Status')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "statusId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedStatuses,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStatuses) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.translate('select Status')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: status.id,
                              value: status.id
                            }, _toDisplayString(status.nameEn), 9, _hoisted_41))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_ErrorMessage, { name: "statusId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, [
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.translate('Class Category')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "classCategoryId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedCategory,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategory) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.translate('select Class Category')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.id
                            }, _toDisplayString(category.nameEn), 9, _hoisted_49))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_ErrorMessage, { name: "classCategoryId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.translate('Class Level')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "classLevelId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedLevel,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLevel) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_56, _toDisplayString(_ctx.translate('select Class Level')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchedClassLevelList, (level) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: level.id,
                              value: level.id
                            }, _toDisplayString(level.name), 9, _hoisted_57))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_ErrorMessage, { name: "classLevelId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, [
                      _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate('Customer Type')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "typeId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedCustomers,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCustomers) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.translate('select Customer Type')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: customer.id,
                              value: customer.id
                            }, _toDisplayString(customer.nameEn), 9, _hoisted_65))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_ErrorMessage, { name: "typeId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.translate('Civil ID')), 1),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "civilId",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Civil ID')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_ErrorMessage, { name: "civilId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.translate('passport')), 1),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "passportNumber",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('passport')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_ErrorMessage, { name: "passportNumber" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.translate('Address')), 1),
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "address",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Address')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createVNode(_component_ErrorMessage, { name: "address" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.translate('Date Of Birth')), 1),
                    _createElementVNode("div", _hoisted_85, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.dateOfBirth,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
                        type: "date",
                        name: "dateOfBirth",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePicker, {
                            id: "dateOfBirth",
                            class: "form-control form-control-lg form-control-solid",
                            modelValue: _ctx.dateOfBirth,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
                            placeholder: _ctx.translate('dd/mm/yyyy'),
                            fieldId: "dateOfBirth"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createVNode(_component_ErrorMessage, { name: "dateOfBirth" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.translate('Age')), 1),
                    _createElementVNode("div", _hoisted_90, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "age",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Age'),
                        disabled: "true",
                        modelValue: _ctx.ageInYear,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ageInYear) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Preferred Days')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createVNode(_component_Field, {
                        name: "preferredDays",
                        modelValue: _ctx.selectedDayes,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDayes) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.selectedDayes,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDayes) = $event)),
                            mode: "tags",
                            "close-on-select": false,
                            requiered: true,
                            label: "title",
                            trackBy: "title",
                            searchable: true,
                            canDeselect: false,
                            placeholder: _ctx.translate('Select Days'),
                            options: _ctx.preferredDayes,
                            valueProp: "id",
                            noResultsText: _ctx.translate('noResultsFound'),
                            "allow-empty": false,
                            required: true
                          }, null, 8, ["modelValue", "placeholder", "options", "noResultsText"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createVNode(_component_ErrorMessage, { name: "preferredDays" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("label", _hoisted_97, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Free Registration')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.freeRegistration) = $event)),
                        class: "form-check-input",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.freeRegistration]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Horse Owner')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.horseOwner) = $event)),
                        class: "form-check-input",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.horseOwner]
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactList, (contact, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-6",
                      key: index
                    }, [
                      _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.translate('Contact')) + " " + _toDisplayString(index + 1), 1),
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _createVNode(_component_Field, {
                                name: 'contactList[' + index + '].phone',
                                onChange: ($event: any) => (contact.phone = $event.target.value),
                                type: "text",
                                modelValue: contact.phone,
                                "onUpdate:modelValue": ($event: any) => ((contact.phone) = $event),
                                class: "form-control"
                              }, null, 8, ["name", "onChange", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createVNode(_component_ErrorMessage, {
                                  name: 'contactList[' + index + '].phone'
                                }, null, 8, ["name"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (index > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createVNode(_component_Field, {
                              name: 'interNationalContactList[' + index + '].phone',
                              type: "text",
                              modelValue: contact.phone,
                              "onUpdate:modelValue": ($event: any) => ((contact.phone) = $event),
                              class: "form-control"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_vue_tel_input, {
                                  defaultCountry: 'KW',
                                  class: "form-control",
                                  modelValue: contact.phone,
                                  "onUpdate:modelValue": ($event: any) => ((contact.phone) = $event),
                                  mode: "international",
                                  onValidate: 
                    (phoneObject) => _ctx.validateNumbers(phoneObject, index)
                  
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onValidate"])
                              ]),
                              _: 2
                            }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("div", _hoisted_110, [
                                (
                      _ctx.isInternationalPhoneValid &&
                      !_ctx.isInternationalPhoneValid[index]
                    )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_111, "International phone number is not valid "))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.primaryContactIndex) = $event)),
                            class: "form-radio-input form-control-lg",
                            type: "radio",
                            value: index,
                            name: "primaryContact"
                          }, null, 8, _hoisted_114), [
                            [_vModelRadio, _ctx.primaryContactIndex]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: _ctx.contactList.length === 1,
                            onClick: _withModifiers(($event: any) => (_ctx.removeContact(index)), ["prevent"]),
                            class: "mx-4 btn btn-sm btn-primary"
                          }, " Remove ", 8, _hoisted_115)
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_116, [
                    _hoisted_117,
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addContact && _ctx.addContact(...args)), ["prevent"])),
                        class: "btn btn-primary"
                      }, [
                        _createElementVNode("span", _hoisted_119, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_121, [
                    _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_123, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_124
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Attachment, {
      isDisabled: !_ctx.customerId,
      onSubmitCreate: _ctx.onSubmitCreateAttachment
    }, null, 8, ["isDisabled", "onSubmitCreate"]),
    _createElementVNode("div", _hoisted_125, [
      _createElementVNode("div", _hoisted_126, [
        _createElementVNode("div", _hoisted_127, [
          _createElementVNode("h3", _hoisted_128, _toDisplayString(_ctx.translate('Guardians')), 1)
        ])
      ]),
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmitCreateGuardian,
        "validation-schema": _ctx.guardianValidation
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("table", _hoisted_130, [
              _hoisted_131,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (customer, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_Field, {
                        name: `name_${index}`,
                        modelValue: customer.name,
                        "onUpdate:modelValue": ($event: any) => ((customer.name) = $event),
                        class: "form-control"
                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          _createVNode(_component_ErrorMessage, {
                            name: `name_${index}`
                          }, null, 8, ["name"])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_Field, {
                        name: `email_${index}`,
                        type: "email",
                        modelValue: customer.email,
                        "onUpdate:modelValue": ($event: any) => ((customer.email) = $event),
                        class: "form-control"
                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("div", _hoisted_135, [
                          _createVNode(_component_ErrorMessage, {
                            name: `email_${index}`
                          }, null, 8, ["name"])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_136, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: `typeId_${index}`,
                          class: "form-select form-select-solid form-select-lg text-capitalize",
                          modelValue: customer.typeId,
                          "onUpdate:modelValue": ($event: any) => ((customer.typeId) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("option", _hoisted_137, _toDisplayString(_ctx.translate('select Guardians Type')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guardians, (guardian) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: guardian.id,
                                value: guardian.id
                              }, _toDisplayString(guardian.nameEn), 9, _hoisted_138))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", _hoisted_140, [
                            _createVNode(_component_ErrorMessage, {
                              name: `typeId_${index}`
                            }, null, 8, ["name"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_141, [
                        _hoisted_142,
                        _createVNode(_component_Field, {
                          name: `phone_${index}`,
                          type: "number",
                          modelValue: customer.phone,
                          "onUpdate:modelValue": ($event: any) => ((customer.phone) = $event),
                          value: `965${customer.phone}`,
                          class: "form-control"
                        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("div", _hoisted_144, [
                          _createVNode(_component_ErrorMessage, {
                            name: `phone_${index}`
                          }, null, 8, ["name"])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.deleteCustomer(index)),
                        class: "btn btn-danger"
                      }, " Delete ", 8, _hoisted_145)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.tableData.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_146, " Please add new Guardian using the \"Add New Guardian\" button "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewRow && _ctx.addNewRow(...args)), ["prevent"])),
              class: "btn btn-success"
            }, " Add New Guardian "),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton",
                class: "btn btn-primary",
                disabled: !_ctx.customerId
              }, [
                _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_150, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_151
                ])
              ], 8, _hoisted_148)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}